import * as React from 'react';
import PropTypes from 'prop-types';
import HotTable from "react-handsontable";
import Handsontable from "handsontable";
import _ from 'lodash';
import ChartComponent, { Line } from 'react-chartjs-2';
import { FormattedNumber, injectIntl } from 'react-intl';
import PPIYearService from "../../../service/sfp/ppi-year-service";

const PROP_NAMES = { LABEL: "label" }

class GeneralComponent extends React.Component {
    constructor(props) {
        super(props);
        this.apiCallTimeout = null;
    }

    render() {
        const chartOptions = {
            maintainAspectRatio: false,
            scales: {
                xAxes: [{ offset: true }],
                yAxes: [{
                    ticks: {
                        callback: (value, index, values) => (
                            this.props.intl.formatNumber(value, { currency: "EUR", style: "currency" })
                        )
                    }
                }]
            },
            tooltips: {
                callbacks: {
                    label: (tooltip, data) => {
                        const datasetIndex = tooltip.datasetIndex
                        const dataIndex = tooltip.index
                        const value = data.datasets[datasetIndex].data[dataIndex]
                        const formattedValue = this.props.intl.formatNumber(value, { currency: "EUR", style: "currency" })
                        return `${data.labels[dataIndex]} : ${formattedValue}`
                    }
                }
            }
        }

        const years = this.props.years
        const settings = {
            cells: function (row, col, prop) {
                // getting source data of the row
                const rowData = this.instance.getSourceDataAtRow(row)
                // creating cell properties
                const cellProps = {
                    renderer: function (instance, TD, row, col, prop2, value, cellProperties) {
                        if ("label" !== prop) { // if prop is not label (ex.: 2013, 2012, etc.)
                            // applying the numeric renderer
                            Handsontable.renderers.NumericRenderer.apply(this, arguments)
                        } else {
                            // applying the text renderer
                            Handsontable.renderers.TextRenderer.apply(this, arguments)
                        }

                        // setting styles depending of rowData
                        if (rowData && rowData.isTitle) {
                            TD.style.fontWeight = "bold"
                        }
                    }
                }

                if (rowData && !rowData.isCurrency) cellProps.format = "0,0"

                return cellProps
            },
            colHeaders: _.concat([""], years),
            columns: [
                { data: PROP_NAMES.LABEL },
                ...this._getYearColumns(years)
            ],
            data: this.props.tableResData,
            height: 200,
            fixedColumnsLeft: 1,
            maxRows: 3,
            readOnly: true,
            stretchH: "all"
        }

        return (

            <div>
                <HotTable settings={settings} />
                <div style={{ position: "relative", height: "300px" }}>
                    <Line data={this.props.chartData} options={chartOptions} />
                </div>
                <p style={{ textAlign: "center" }}>Vous pouvez cacher un élément sur le graphique en cliquant sur sa légende.</p>
            </div>
        );
    }

    componentDidUpdate(prevProps, prevState) {
        const lastYear = new Date().getFullYear() - 1;
        if (this.props.tableResData && this.props.tableResData.length > 0 && this.props.tableResData[1][lastYear]) {
            if (this.apiCallTimeout) {
                clearTimeout(this.apiCallTimeout);
            }
            this.apiCallTimeout = setTimeout(() => {
                // tableResData contient 3 lignes dont la seconde contient le résultat des investissements
                const investResult = _.round(this.props.tableResData[1][lastYear], 2);
                PPIYearService.updatePPIYearInvestResult(this.props.localAuthorityId, lastYear, investResult);
                this.apiCallTimeout = null;
            }, 5000);
        }
    }

    _getYearColumns = (years) => {
        const columns = []
        const firstYear = years[0]

        for (let i = firstYear; i < firstYear + years.length; i++) {
            columns.push({ data: i.toString(), format: "0,0.00 $", language: "fr-FR", type: "numeric" })
        }

        return columns
    }

    _getCurrencyNumber = (value) => <FormattedNumber currency="EUR" style="currency" value={value} />
}

export default injectIntl(GeneralComponent)

GeneralComponent.propTypes = {
    chartData: ChartComponent.propTypes.data,
    loading: PropTypes.bool.isRequired,
    singled: PropTypes.bool,
    tableResData: PropTypes.array.isRequired,
    years: PropTypes.arrayOf(PropTypes.number).isRequired
}


// WEBPACK FOOTER //
// ./src/component/summary/general/general-component.js